<template>
<div style="">
  <v-card class="d-flex flex-column" flat style="height:75vh">
    <div class="overflow-y-auto overflow-x-hidden mt-2 px-2" :class="{h55 : !isMention&&$mq==='pc', h50 : isMention&&$mq==='pc', h70 : !isMention&&$mq==='sp', h66 : isMention&&$mq==='sp'}" v-if="contentType==='comments'">
      <v-card-text class="text-center font-weight-bold" color="#2B2B2B" v-if="pjcomments.length === 0 && !aboutLid.kaizenTeianEnabled">まだ誰もチャットを使っていません!<br>この{{$t('プロジェクト')}}案について、議論しましょう!<br><span v-if="project_amdOpen">良い意見があれば、「修正提案」する事ができます</span></v-card-text>
      <v-card class="mb-4" elevation="0" v-for="(comm, index) in pjcomments" :key="comm.sort">
        <v-row v-if="comm.author===uid||anonymitys.includes(comm.id)">
          <v-col cols="2" class="d-flex flex-column pr-1">
            <v-card elevation="0" class="d-flex flex-column mt-auto pl-0">
              <v-card-actions class="pa-0 mx-auto mt-auto">
                <p class="my-0" style="font-size:12px;" v-if="timeday==comm.day">{{comm.hour}}</p>
                <p class="my-0" style="font-size:12px;" v-else>{{comm.day}}</p>
              </v-card-actions>
              <v-card-actions class="pa-0 mx-auto">
                <template>
                  <v-btn class="mb-0 pl-0" text icon elevation="0"  height="30" width="45" @click="contentUid = comm.id,contentType='comments',doLike(index,comm.like.includes(uid))" :disabled="!isAuthed||!aboutLid.sanka||!aboutpj.sanka||isPro===true">
                    <v-icon size="23" :color="comm.like.includes(uid) ? 'shallowAqua' : 'shallowCloud'">mdi-thumb-up </v-icon>
                    <v-card-text :color="comm.like.includes(uid) ? 'shallowAqua' : 'shallowCloud'" class="pa-0 text-right" v-if="comm.like.length>0&&isAdmin"><span v-text="comm.like.length"></span></v-card-text>
                  </v-btn>
                </template>
              </v-card-actions>
              <v-card-text :color="comm.like.includes(uid) ? 'shallowAqua' : 'shallowCloud'" class="pa-0 text-center" style="font-size: x-small;" v-if="comm.like.length>0&&!isAdmin">いいね有</v-card-text>
            </v-card>
          </v-col>
          <v-col cols="10" class="pl-0 pr-4">
            <v-chip
              v-if="comm.tag&&comm.tag.title"
              style="background-color: #dcdcdc;position: relative;left: -10px;top: 16px;z-index:20;"
            >
              <v-icon :color="comm.tag.color" size="20">mdi-checkbox-blank-circle</v-icon>
              <p class="mb-0" style="font-size:14px; white-space:nowrap; text-overflow: ellipsis; overflow:hidden;">
                &nbsp;{{ comm.tag.title }}
              </p>
            </v-chip>
            <v-card outlined class="mt-0 d-flex flex-row sky" style="border-radius: 10px 0px 10px 10px;">
              <v-card-actions class="d-flex flex-column">
                <div class="pa-2 overflow-y-auto chat-scroll" style="max-height:20dvh;">
                  <v-card-text v-if="comm&&comm.isMention" v-text="'@'+namelist[comm.mentionId]" class="pa-0 mb-2" style="background-color:#CCE8FF; color:#294A66;"></v-card-text>
                  <v-card-text class="pa-0 text-left" v-text="comm.content"></v-card-text>
                  <span v-if="comm.edit" style="font-size:6px; color:#707070;">(編集済み)</span>
                  <span v-if="comm.anonymous||anonymitys.includes(comm.id)" style="font-size:6px; color:#707070;">(匿名投稿)</span>
                  <v-card-text v-if="comm&&comm.isReply" v-text="pjcomments[pjcomments.findIndex(el => el.id == comm.replyId)].content" class="entire py-0 pr-0"></v-card-text>
                </div>
                <v-img v-if="comm.chatImage" @click.native="images=true,dialog_image=comm.chatImage" :src="comm.chatImage" class="mx-auto mt-1" width="230px" height="10dvh" />
              </v-card-actions>
              <v-card-actions class="d-flex align-start ml-auto">
                <div class="">
                  <!--mdi-dots-vertical-->
                  <v-menu top v-if="(comm.author===uid||anonymitys.includes(comm.id))&&!isPro">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="#2B2B2B" icon v-bind="attrs" v-on="on" @click="contentUid = comm.id">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list class="pb-0 pt-0">
                      <v-list-item @click="isReply = true,replyContent = comm.content,replyId = comm.id">
                        <v-list-item-title>コメントに返信する</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="contentUid = comm.id,editPage = true, editContent = comm.content,contentType = 'comments'">
                        <v-list-item-title>コメントを編集する</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="contentUid = comm.id,deleteAlert = true,contentType = 'comments'" dark style="background-color:#E64550;">
                        <v-list-item-title>コメントを削除する</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-btn v-else-if="isAuthed&&aboutLid.sanka&&aboutpj.sanka&&!isPro" color="#2B2B2B" icon @click="isReply = true,replyContent = comm.content,replyId = comm.id"><v-icon>mdi-reply</v-icon></v-btn>
                </div>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col cols="1">
            <!--chat作者-->
            <div style="color:#2B2B2B !important;" class="d-flex">
              <v-btn v-if="comm.author!='anonymity'" small icon @click="profileUid = comm.author,profile = true">
                <v-avatar size="30">
                  <img v-bind:src="profImageDict[comm.author]">
                </v-avatar>
              </v-btn>
              <v-icon v-else size="30" style="color:rgba(128,128,128,0.4)!important;">mdi-account-circle</v-icon>
            </div>
          </v-col>
          <v-col cols="9" class="px-0">
            <v-chip
              v-if="comm.tag&&comm.tag.title"
              style="background-color: #dcdcdc;position: relative;left: -10px;top: 54px;z-index:20;"
            >
              <v-icon :color="comm.tag.color" size="20">mdi-checkbox-blank-circle</v-icon>
              <p class="mb-0" style="font-size:14px; white-space:nowrap; text-overflow: ellipsis; overflow:hidden;">
                &nbsp;{{ comm.tag.title }}
              </p>
            </v-chip>
            <v-card-text class="pt-0 pl-4" style="font-size:15px;" v-if="comm.author!='anonymity'">{{ namelist[comm.author] }}<span v-if="baseAdmins.gov.includes(comm.author)" class="cloud--text" style="font-size: small;"> 管理者</span></v-card-text>
            <v-card-text class="pt-0 pl-4" style="font-size:15px;" v-else>匿名</v-card-text>
            <v-card outlined class="mt-0 d-flex flex-row" style="border-radius: 0px 10px 10px 10px;" :class="{faintHoney : (baseAdmins.gov.includes(comm.author)||baseAdmins.liq.includes(comm.author))}">
              <v-card-actions class="d-flex flex-column">
                <div class="pa-2 overflow-y-auto chat-scroll" style="max-height:20dvh;">
                  <v-card-text v-if="comm&&comm.isMention" v-text="'@'+namelist[comm.mentionId]" class="pa-0 mb-2" style="background-color:#CCE8FF; color:#294A66;"></v-card-text>
                  <v-card-text class="pa-0" v-text="comm.content"></v-card-text>
                  <span v-if="comm.edit" style="font-size:6px; color:#707070;">(編集済み)</span>
                  <v-card-text v-if="comm&&comm.isReply&&pjcomments[pjcomments.findIndex(el => el.id == comm.replyId)]" v-text="pjcomments[pjcomments.findIndex(el => el.id == comm.replyId)].content" class="entire py-0 pr-0"></v-card-text>
                </div>
                <v-img v-if="comm.chatImage" :src="comm.chatImage" @click.native="images=true,dialog_image=comm.chatImage" class="mx-auto mt-1" max-width="200px" height="10dvh" />
              </v-card-actions>
              <v-card-actions class="d-flex align-start ml-auto">
                <v-btn v-if="isAuthed&&aboutLid.sanka&&aboutpj.sanka&&isPro!==true" color="#2B2B2B" icon @click="isReply = true,replyContent = comm.content,replyId = comm.id"><v-icon>mdi-reply</v-icon></v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="2" class="d-flex flex-column pl-2">
            <v-card elevation="0" class="d-flex flex-column mt-auto">
              <v-card-actions class="pa-0 mr-auto mt-auto">
                <p class="mb-0" style="font-size:12px;" v-if="timeday==comm.day">{{comm.hour}}</p>
                <p class="mb-0" style="font-size:12px;" v-else>{{comm.day}}</p>
              </v-card-actions>
              <v-card-actions class="pa-0 mr-auto">
                <template>
                  <v-btn class="mb-0 pl-0" text icon elevation="0"  height="30" width="45" @click="contentUid = comm.id,contentType='comments',doLike(index,comm.like.includes(uid))" :disabled="!isAuthed||!aboutLid.sanka||!aboutpj.sanka||isPro===true">
                    <v-icon size="23" :color="comm.like.includes(uid) ? 'shallowAqua' : 'shallowCloud'">mdi-thumb-up </v-icon>
                    <v-card-text :color="comm.like.includes(uid) ? 'shallowAqua' : 'shallowCloud'" class="pa-0 text-right" v-if="comm.like.length>0&&isAdmin"><span v-text="comm.like.length"></span></v-card-text>
                  </v-btn>
                </template>
              </v-card-actions>
              <v-card-text :color="comm.like.includes(uid) ? 'shallowAqua' : 'shallowCloud'" class="pa-0 text-left" style="font-size: x-small;" v-if="comm.like.length>0&&!isAdmin">いいね有</v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </div>
    <div class="overflow-y-auto overflow-x-hidden mt-2 px-2" :class="{h50 : isMention&&$mq!=='sp',h72 : $mq==='sp',h55 : !isMention&&$mq!=='sp'}" v-if="contentType==='amendments'">
      <v-card-text class="text-center font-weight-bold" color="#2B2B2B" v-if="pjamendments.length === 0">まだ誰も修正提案を投稿していません!<br>この{{$t('プロジェクト')}}案について、議論しましょう!</v-card-text>
      <v-card v-for="(amend, index) in pjamendments" :key="amend.sort" style="border-radius: 5px;" class="my-4">
        <v-card-actions elevation="0" style="border-radius: 0px; background-color:#399942;">
          <v-card-text class="white--text pa-0" style="height:30px; font-size:18px; display:flex; align-items:center;">
            {{namelist[amend.author]}}
          </v-card-text>
          <v-menu top v-if="amend.author===uid&&!isPro">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="white" class="dotbtn" icon v-bind="attrs" v-on="on" @click="contentUid = amend.id">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list class="pb-0 pt-0">
              <v-list-item @click="contentUid = amend.id,editPage = true, editContent = amend.content,contentType = 'amendments'">
                <v-list-item-title>修正提案を編集する</v-list-item-title>
              </v-list-item>
              <v-list-item @click="contentUid = amend.id,deleteAlert = true,contentType = 'amendments'" dark style="background-color:#E64550;">
                <v-list-item-title>修正提案を削除する</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-card-actions>
        <v-card-text class="pa-2 overflow-y-auto chat-scroll" style="font-size: 100%; padding: 0px; max-height:20dvh; color:#2B2B2B;">
          <span v-text="amend.content"></span>
          <span v-if="amend.edit" style="font-size:6px; color:#707070;">  (編集済み)</span>
        </v-card-text>
        <v-card-actions class="d-flex justify-space-between pb-0">
          <v-card-text class="pa-0">{{amend.day}} {{amend.hour}} </v-card-text> 
          <div class="d-flex align-center py-1">
            <v-btn class="mb-0 pl-0" text icon elevation="0"  height="30" width="45" @click="contentUid = amend.id,contentType='amendments',doLike(index,amend.like.includes(uid))" :disabled="!isAuthed||!aboutLid.sanka||!aboutpj.sanka||isPro===true">
              <v-icon size="23" :color="amend.like.includes(uid) ? 'shallowAqua' : 'shallowCloud'">mdi-thumb-up </v-icon>
              <v-card-text :color="amend.like.includes(uid) ? 'shallowAqua' : 'shallowCloud'" class="pa-0 text-left" v-if="amend.like.length>0&&isAdmin"><span v-text="amend.like.length"></span></v-card-text>
              <v-card-text :color="amend.like.includes(uid) ? 'shallowAqua' : 'shallowCloud'" class="pa-0 pr-2" style="font-size: x-small;" v-if="amend.like.length>0&&!isAdmin">いいね有</v-card-text>
            </v-btn>
            <v-btn small class="px-2 white--text rounded-pill" color="#008CFF" @click="$emit('addAmends',amend.id)" v-if="isPro&&!amends.includes(amend.id)">採用する</v-btn>
						<v-btn small class="px-2 white--text rounded-pill" color="#BA0009" @click="$emit('addAmends',amend.id)" v-else-if="isPro">採用済み</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </div>
    <!--アイデア スレッド-->
    <div class="overflow-y-auto overflow-x-hidden mt-2 px-2" :class="{h55 : !isMention&&$mq==='pc', h50 : (isMention||isReply)&&$mq==='pc', h70 : !isMention&&$mq==='sp', h66 : isMention&&$mq==='sp'}" v-if="contentType==='idea'">
      <v-card-text class="text-center font-weight-bold" color="#2B2B2B" v-if="ideaThreads.length === 0">まだ誰もコメントを投稿していません!<br>この{{$t('アイデア')}}について、コメントを投稿しましょう!</v-card-text>
      <v-card v-for="(ideat, index) in ideaThreads" :key="ideat.sort" style="border-radius: 5px;" class="my-4" flat>
        <v-row v-if="ideat.author===uid||anonymitys.includes(ideat.id)">
          <v-col cols="2" class="d-flex flex-column pr-1">
            <v-card elevation="0" class="d-flex flex-column mt-auto pl-0">
              <v-card-actions class="pa-0 mx-auto mt-auto">
                <p class="my-0" style="font-size:12px;" v-if="timeday==ideat.day">{{ideat.hour}}</p>
                <p class="my-0" style="font-size:12px;" v-else>{{ideat.day}}</p>
              </v-card-actions>
              <v-card-actions class="pa-0 mx-auto">
                <template>
                  <v-btn class="mb-0 pl-0" text icon elevation="0"  height="30" width="45" @click="contentUid = ideat.id,contentType='idea',doLike(index,ideat.like.includes(uid))" :disabled="!isAuthed||!aboutLid.sanka">
                    <v-icon size="23" :color="ideat.like.includes(uid) ? 'shallowAqua' : 'shallowCloud'">mdi-thumb-up </v-icon>
                    <v-card-text :color="ideat.like.includes(uid) ? 'shallowAqua' : 'shallowCloud'" class="pa-0 text-right" v-if="ideat.like.length>0&&isAdmin"><span v-text="ideat.like.length"></span></v-card-text>
                  </v-btn>
                </template>
              </v-card-actions>
              <v-card-text :color="ideat.like.includes(uid) ? 'shallowAqua' : 'shallowCloud'" class="pa-0 text-center" style="font-size: x-small;" v-if="ideat.like.length>0&&!isAdmin">いいね有</v-card-text>
            </v-card>
          </v-col>
          <v-col cols="10" class="pl-0 pr-4">
            <v-card outlined class="mt-0 d-flex flex-row sky" style="border-radius: 10px 0px 10px 10px;">
              <v-card-actions class="d-flex">
              <div class="pa-2 overflow-y-auto chat-scroll" style="max-height:20dvh;">
                <v-card-text v-if="ideat&&ideat.isMention" v-text="'@'+namelist[ideat.mentionId]" class="pa-0 mb-2" style="background-color:#CCE8FF; color:#294A66;"></v-card-text>
                <v-card-text class="pa-0" v-text="ideat.content"></v-card-text>
                <span v-if="ideat.edit" style="font-size:6px; color:#707070;">(編集済み)</span>
                <span v-if="ideat.anonymous||anonymitys.includes(ideat.id)" style="font-size:6px; color:#707070;">(匿名投稿)</span>
                <v-card-text v-if="ideat&&ideat.isReply" v-text="ideaThreads[ideaThreads.findIndex(el => el.id == ideat.replyId)].content" class="entire py-0 pr-0"></v-card-text>
              </div>
              </v-card-actions>
              <v-card-actions class="d-flex align-start ml-auto">
              <div class="">
                <!--mdi-dots-vertical-->
                <v-menu top v-if="(ideat.author===uid||anonymitys.includes(ideat.id))">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="#2B2B2B" icon v-bind="attrs" v-on="on" @click="contentUid = ideat.id">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list class="pb-0 pt-0">
                    <v-list-item @click="isReply = true,replyContent = ideat.content,replyId = ideat.id">
                      <v-list-item-title>コメントに返信する</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="contentUid = ideat.id,contentType = 'idea',editPage = true, editContent = ideat.content">
                      <v-list-item-title>コメントを編集する</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="contentUid = ideat.id,contentType = 'idea',deleteAlert = true" dark style="background-color:#E64550;">
                      <v-list-item-title>コメントを削除する</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-btn v-else-if="isAuthed&&aboutLid.sanka" color="#2B2B2B" icon @click="isReply = true,replyContent = ideat.content,replyId = ideat.id"><v-icon>mdi-reply</v-icon></v-btn>
              </div>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col cols="1">
            <!--chat作者-->
            <div style="color:#2B2B2B !important;" class="d-flex">
              <v-btn v-if="ideat.author!='anonymity'" small icon @click="profileUid = ideat.author,profile = true">
                <v-avatar size="30">
                  <img v-bind:src="profImageDict[ideat.author]">
                </v-avatar>
              </v-btn>
              <v-icon v-else size="30" style="color:rgba(128,128,128,0.4)!important;">mdi-account-circle</v-icon>
            </div>
          </v-col>
          <v-col cols="9" class="px-0">
            <v-card-text class="pt-0 pl-4" style="font-size:15px;" v-if="ideat.author!='anonymity'">{{ namelist[ideat.author] }}<span v-if="baseAdmins.gov.includes(ideat.author)" class="cloud--text" style="font-size: small;"> 管理者</span></v-card-text>
            <v-card-text class="pt-0 pl-4" style="font-size:15px;" v-else>匿名</v-card-text>
            <v-card outlined class="mt-0 d-flex flex-row" style="border-radius: 0px 10px 10px 10px;" :class="{faintHoney : (baseAdmins.gov.includes(ideat.author)||baseAdmins.liq.includes(ideat.author))}">
            <v-card-actions class="d-flex">
            <div class="pa-2 overflow-y-auto chat-scroll" style="max-height:20dvh;">
              <v-card-text v-if="ideat&&ideat.isMention" v-text="'@'+namelist[ideat.mentionId]" class="pa-0 mb-2" style="background-color:#CCE8FF; color:#294A66;"></v-card-text>
              <v-card-text class="pa-0" v-text="ideat.content"></v-card-text>
              <span v-if="ideat.edit" style="font-size:6px; color:#707070;">(編集済み)</span>
              <v-card-text v-if="ideat&&ideat.isReply" v-text="ideaThreads[ideaThreads.findIndex(el => el.id == ideat.replyId)].content" class="entire py-0 pr-0"></v-card-text>
            </div>
            </v-card-actions>
            <v-card-actions class="d-flex align-start ml-auto">
              <v-btn v-if="isAuthed&&aboutLid.sanka" color="#2B2B2B" icon @click="isReply = true,replyContent = ideat.content,replyId = ideat.id"><v-icon>mdi-reply</v-icon></v-btn>
            </v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="2" class="d-flex flex-column pl-2">
            <v-card elevation="0" class="d-flex flex-column mt-auto">
              <v-card-actions class="pa-0 mr-auto mt-auto">   
                <p class="mb-0" style="font-size:12px;" v-if="timeday==ideat.day">{{ideat.hour}}</p>
                <p class="mb-0" style="font-size:12px;" v-else>{{ideat.day}}</p>
              </v-card-actions>
              <v-card-actions class="pa-0 mr-auto">
                <template>
                  <v-btn class="mb-0 pl-0" text icon elevation="0"  height="30" width="45" @click="contentUid = ideat.id,contentType='idea',doLike(index,ideat.like.includes(uid))" :disabled="!isAuthed||!aboutLid.sanka">
                    <v-icon size="23" :color="ideat.like.includes(uid) ? 'shallowAqua' : 'shallowCloud'">mdi-thumb-up </v-icon>
                    <v-card-text :color="ideat.like.includes(uid) ? 'shallowAqua' : 'shallowCloud'" class="pa-0 text-right" v-if="ideat.like.length>0&&isAdmin"><span v-text="ideat.like.length"></span></v-card-text>
                  </v-btn>
                </template>
              </v-card-actions>
              <v-card-text :color="ideat.like.includes(uid) ? 'shallowAqua' : 'shallowCloud'" class="pa-0 text-left" style="font-size: x-small;" v-if="ideat.like.length>0&&!isAdmin">いいね有</v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </div>
    <!-- ボックスの最下部に固定する styleが付加されたdiv -->
    <div style="height:auto; width: 100%; position: relative; bottom: 0px; left: 0px;">

      <div v-if="!isAuthed&&!isPro" class="d-flex py-4 align-center justify-center">
        <p class="mb-0" style="font-size:12px;">ログインして、議論に参加しましょう！</p>
        <v-btn class="rounded-pill px-2 ml-4" style="background-color: #008CFF" @click="authModal = true" dark>ログイン</v-btn>
      </div>
      <div v-else-if="aboutLid&&!aboutLid.sanka&&!isPro" class="d-flex py-4 align-center justify-center" style="height:110px;">
        <p class="mb-0" style="font-size:12px;">{{ $t('Lid') }}に参加して、議論に参加しましょう！</p>
        <v-btn class="rounded-pill px-2 ml-4" style="background-color: #008CFF" @click="LidSankaAlert = true" dark>{{ $t('Lid') }}に参加</v-btn>
      </div>
      <div v-else-if="isAuthed&&isPro!==true" class="mx-2">
        <div class="d-flex align-center" v-if="isReply&&(contentType==='comments'||contentType==='idea')">
          <p v-if="chatImage" class="mb-0 mr-2" style="max-width:90%; height:25px; color:#707070;">画像添付済</p>
          <p class="mb-0 overflow-hidden" style="max-width:90%; height:25px; color:#707070;">返信：<span v-text="replyContent"></span></p>
          <v-btn class="ma-0 py-0 px-2 ml-auto" @click="isReply = false">キャンセル</v-btn>
        </div>
        <div class="d-flex align-center" v-if="isMention&&(contentType==='comments'||contentType==='idea')">
          <p v-if="chatImage" class="mb-0 mr-2" style="max-width:90%; height:25px; color:#707070;">画像添付済</p>
          <p class="mb-0 overflow-hidden" style="max-width:90%; height:25px; color:#707070;">メンション：@<span v-text="namelist[mentionId]"></span></p>
          <v-btn class="ma-0 py-0 px-2 ml-auto" @click="isMention = false,mentionId=''">キャンセル</v-btn>
        </div>
        <div class="d-flex align-center" v-if="(contentType==='comments'||contentType==='idea') && !isIdeaThreadAndSubmmisionDisabled">
          <v-select
            v-if="aboutLid.kaizenTeianEnabled"
            v-model="tag"
            :items="tags"
            menu-props="{ top: true, offsetY: true }"
            label="追記先を選択してください"
            hide-details
            prepend-inner-icon="mdi-circle"
            single-line
            dense
            outlined
            @change="fetchTitle($event)" 
            :color="postcolor"
            :error="aboutLid.tags.required && !tag"
            clearable
          >
          </v-select>
        </div>
        <div class="d-flex align-center" v-if="(contentType==='comments'||contentType==='idea') && !isIdeaThreadAndSubmmisionDisabled">
          <!-- <v-icon v-if="tag" :color="postcolor" size="24" style="position: absolute;top: 18px;left: 8px;margin-left: 12px;z-index: 500;">mdi-circle</v-icon> -->
          <v-checkbox class="my-0 py-0 disablevm" v-model="isAnonymity" label="匿名投稿する"></v-checkbox>

          <v-menu
            top
            :offset-y="offset"
          >
            <template v-slot:activator="{ on, attrs }">
              <p class="mb-1 ml-4" style="font-size:24px;" :style="!mentionId ? 'color:#707070;' : 'color:#008cff;'" v-bind="attrs" v-on="on">@</p>
            </template>
            <p class="text-center shallowCloud mb-0 py-2">メンションする</p>
            <v-list max-height="350px" class="overflow-y-auto mt-0 pt-0" v-if="contentType!=='idea'">
              <v-list-item
                v-for="(item, index) in pjusers"
                :key="index"
                @click="isMention=true,mentionId=item.uid"
              >
                  <v-avatar size="25" v-if="profImageDict[item.uid]">
                    <img v-bind:src="profImageDict[item.uid]">
                  </v-avatar>
                <v-icon size="25" v-else style="color:rgba(128,128,128,0.4)!important;">mdi-account-circle</v-icon>
                <v-list-item-title class="ml-1">{{ namelist[item.uid] }}</v-list-item-title>
              </v-list-item>
            </v-list>
            <v-list max-height="350px" class="overflow-y-auto mt-0 pt-0" v-else>
              <v-list-item
                v-for="(item, index) in lidusers"
                :key="index"
                @click="isMention=true,mentionId=item.uid"
              >
                  <v-avatar size="25" v-if="profImageDict[item.uid]">
                    <img v-bind:src="profImageDict[item.uid]">
                  </v-avatar>
                <v-icon size="25" v-else style="color:rgba(128,128,128,0.4)!important;">mdi-account-circle</v-icon>
                <v-list-item-title class="ml-1">{{ namelist[item.uid] }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <!--||contentType==='idea'-->
          <v-btn v-if="contentType==='comments'" class="input-item" icon>
            <label>
              <v-icon :color="!chatImage ? '#707070' : '#008cff'">mdi-file-image-plus-outline</v-icon>
              <input type="file" @change="onFileChange"/>
            </label>
          </v-btn>
        </div>
        <div v-if="!isIdeaThreadAndSubmmisionDisabled" class="d-flex align-center">
          <v-textarea hide-details no-resize  class="ma-2 pa-0 chat-scroll" rows="2" row-height="5" placeholder="チャットを入力" outlined background-color="#DCDCDC" v-model="comment" v-on:keydown.enter.ctrl.exact="submitctrl()"></v-textarea>
          <v-btn dark class="rounded-lg mt-2" :class='{shallowCloud:comment.length <= 0}' color="#399942" style="cursor: pointer; font-size: 16px;" @click="submitComment()" hide-details>送信</v-btn>          
        </div>
      </div>
      <div v-else-if="chatImage" class="d-flex py-4 align-center justify-center"> 
        <p v-if="chatImage" class="mb-0" style="font-size:12px;">画像添付済</p>
      </div>
    </div>
  </v-card>

  <!--プロフィール画面-->
  <profile_display
    :profile="profile"
    :profuid="profileUid"
    device="pc"
    @closeProfile="closeProfile"
  ></profile_display>

<!--編集画面-->
<v-dialog v-model="editPage" width="40%" height="60%" class="pa-8 z1000" @keydown.esc="editPage = false" :fullscreen="$mq==='sp'">
  <v-card>
    <v-card-actions>
      <h3 class="pa-2">投稿を編集</h3>
      <v-spacer></v-spacer>
      <v-btn icon @click="editPage = false"><v-icon x-large>mdi-close</v-icon></v-btn>
    </v-card-actions>
    <v-textarea v-model="editContent" outlined background-color="white" color="#707070" class="pa-4" rows="6" counter
      no-resize v-on:keydown.enter.ctrl.exact="editctrl()"></v-textarea>
    <v-card-actions class="pa-2">
      <v-spacer></v-spacer>
      <v-card-actions class="text-right">
        <v-spacer></v-spacer>
        <v-btn class="my-2 mr-2 deepAqua white--text" large rounded :disabled="editContent.length<1" @click="doEditContent() ,editContent='' ,editPage = false">更新</v-btn>                  
      </v-card-actions>
    </v-card-actions>
  </v-card>
</v-dialog>

<!--削除確認画面-->
<v-dialog v-model="deleteAlert" width="800" class="z1000">
  <v-card color="white" elevation="15" class="pt-6">
    <p class="font-weight-bold pt-6 px-8 text-h5 text-center"><font color="black">本当にこの<span v-if="contentType==='comments'">コメント</span><span v-if="contentType==='amendments'">修正提案</span>を削除しますか？</font></p>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-chip class="ma-4 pa-4 font-weight-bold" @click="deleteAlert = false">削除しない</v-chip>
      <v-chip class="ma-4 pa-4 font-weight-bold deepLava" @click="deleteAlert = false, doDeleteContent()" dark>削除する</v-chip>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</v-dialog>

<!--削除確認画面-->
<v-dialog v-model="same" width="800" class="z1000" style="z-index: 1000;">
  <v-card color="white" elevation="15" class="pt-6">
    <p class="font-weight-bold pt-6 px-8 text-h5 text-center">前に送ったチャットと同じ文章が入力されています。</p>
    <p class="font-weight-bold pt-6 px-8 text-h5 text-center">入力しなおしてください。</p>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-chip class="ma-4 pa-4 font-weight-bold" @click="same = false">確認</v-chip>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</v-dialog>

<!--idea画像拡大時-->
<v-dialog v-model="images"
  fullscreen
  hide-overlay
  transition="dialog-bottom-transition"
  style="z-index: 1000;"
>
  <v-card style="background-color: #212121;">
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn x-large fab @click="images=false">
        <v-icon color="#E64550" x-large>mdi-close</v-icon>
      </v-btn>
    </v-card-actions>
    <v-img contain max-height="80vh" :src="dialog_image" :alt="`${$t('アイデア')}の画像`"></v-img>
  </v-card>
</v-dialog>

<!--サインイン画面-->
<v-dialog v-model="authModal" width="400px" height="60%" class="z1000">
  <auth-view
    v-if="authModal"
    defaultView="chooseauth"
    @closeModal="closeAuthModal"
  >
  </auth-view>
</v-dialog>

<!--Lid参加確認画面-->
<v-dialog v-model="LidSankaAlert" width="800" class="z1000">
  <v-card elevation="15" class="pt-6">
    <v-card-actions class="d-flex justify-center align-center">
      <div>
        <p class="font-weight-bold text-h5 text-center">あなたはこの{{ $t('Lid') }}に参加していません。</p>
        <p class="font-weight-bold text-h5 text-center mb-0">この{{ $t('Lid') }}に参加しますか？</p>        
      </div>
    </v-card-actions>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-chip class="ma-4 pa-4" @click="LidSankaAlert = false" >参加しない</v-chip>
      <v-chip class="ma-4 pa-4" @click="LidSankaAlert = false, $store.dispatch('inLid',{lidId:$route.params.id,uid:uid})" color="deepAqua" dark>参加</v-chip>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</v-dialog>

<v-dialog v-model="havetask" width="600" style="background: white">
  <v-card class="pa-6">
    <v-card-text class="text-center">
      画像を確認中...
    </v-card-text>
  </v-card>
</v-dialog>

<activity_function ref="activityfunc" />
</div>
</template>
  
<script>
import firebase from "firebase/app"
import "firebase/firestore"
import Compressor from "compressorjs";
import activity_function from '../../components/profile/activity_function.vue'
import profile_display from "../../components/profile/profile_display.vue"
import authView from '../auth/authView.vue';
import Vue from 'vue'
  import VueMq from 'vue-mq'
  Vue.use(VueMq, {
    breakpoints: { // default breakpoints - customize this
      sp: 959,
      pc: 960
    },
    defaultBreakpoint: 'pc' // customize this for SSR
  })
export default{
  components:{
    activity_function,
    profile_display,
    authView
  },
  mounted(){
    this.db = firebase.firestore() // dbインスタンスを初期化
    this.today()
    if(this.contentType === "comments") this.upComment()
    else if(this.contentType === "amendments") this.upAmendment()
    if (this.aboutLid.kaizenTeianEnabled && this.aboutpj.kaizenTeianKadaiId) {
      this.getKaizenTeianIdeas(this.aboutpj.kaizenTeianKadaiId)
    }
  },
  props:{
    pjuid: String,
    contentType: String,
    aboutpj: Object,
    isPro: Boolean,
    amends: Array,
    ideaThreads: Array,
    ideaId: String
  },
  data: (vm) => ({
    pjcomments: [],
    pjamendments: [],
    db: null,
    offset: true,

    //dialog
    editPage: false,
    deleteAlert: false,
    LidSankaAlert: false,
    images:false,
    same:false,
    dialog_image: "",

    //comm
    comment: "",
    comment_: "",
    contentUid: "",
    editContent: "",
    isAnonymity: false,
    anonymitys: [],
    isReply: false,
    replyContent: "",
    replyId: "",
    isMention: false,
    mentionId: "",
    authModal:false,
    profile: false,
    profileUid: "",

    //時間
    todayy: "",
    timeday: "",
    timehour: "",

    isAC: false, // firebaseのfieldValueがsetだといちいちリセットされてしまい使いにくいので存在する場合はupdate、存在しない場合はsetで対応するためどっちなのかをBooleanで判定

    //画像挿入
    tasks: 0,
    filename: "",
    chatImage: "", // 追加した画像のURL

    // 自分ごと化会議カスタマイズ
    tag: '',
    postcolor: '',
    tags: [],
    tagColors: [],
  }),
  computed:{
    uid() {
      return this.$store.state.auth?.user?.uid || '';
    },
    config(){
      return this.$store.state.config
    },
    namelist(){
      return this.$store.state.namelist
    },
    profImageDict(){
      return this.$store.state.profImageDict
    },
    pjusers() {
      return this.$store.state.pjusers;
    },
    isAdmin() {
      return this.$store.state.isAdmin;
    },
    lid(){
      return this.$store.state.lid
    },
    alid(){
      return this.$store.state.alid
    },
    aboutLid() {
      if (this.$store.state.lid.some((u) => u.id === this.$route.params.id)) {
          return this.$store.state.lid.filter((u) => u.id === this.$route.params.id)[0]
        } else if (this.$store.state.alid.some((u) => u.id === this.$route.params.id)) {
          return this.$store.state.alid.filter((u) => u.id === this.$route.params.id)[0]
        } else {
          return null
        }
    },
    lidusers(){
      return this.$store.state.lidusers
    },
    isAuthed() {
      return this.$store.state.auth?.isAuthed;
    },
    project_amdOpen() {
      if(this.$store.state.config.setting&&this.$store.state.config.setting.project_amdOpen) return !this.$store.state.config.setting.project_amdOpen
      else return true
    },
    baseAdmins(){
      return this.$store.state.admins
    },
    currentName() {
      return this.$store.state.auth.user.displayName;
    },
    isSubmittable(){
      // ログインしていて、コメントが1文字以上であればtrue
      return (
        this.isAuthed &&
        this.comment.length >= 1 &&
        this.comment != this.comment_
      )
    },
    havetask() {
      if (this.tasks > 0) {
        return true;
      } else {
        return false;
      }
    },
    // アイデアのスレッドであり、かつ投稿が管理者のみに限定されている場合に投稿ボタンを非表示にする判定を行う
    isIdeaThreadAndSubmmisionDisabled() {
      if (this.contentType==='idea' && this.$store.state?.config?.setting?.idea_thread_admin_only && !this.isAdmin) return true;
      else return false
    },
  },
  watch:{
    pjuid:{
      handler: function(v,ov) {
        //console.log("pjuid変更検知",ov,v)
        if(this.contentType === "comments") this.upComment()
        else if(this.contentType === "amendments") this.upAmendment()
        this.comment_ = ""
      }
    },
    ideaId:{
      handler: function(v,ov) {
        //console.log("ideaId変更検知",ov,v)
        this.comment_ = ""
        this.comment = ""
      }
    },
    aboutLid: {
      handler: function(v, ov) {
        let tags = this.aboutLid?.tags?.title || []
        let tagColors = this.aboutLid?.tags?.color || []
        let genjoKadaiIndex = tags.findIndex(el => el == '現状の課題')
        if (genjoKadaiIndex > -1) {
          tags.splice(genjoKadaiIndex, 1)
          tagColors.splice(genjoKadaiIndex, 1)
        } else {
          console.log('現状の課題が見つかりませんでした。')
        }
        this.tags = tags
        this.tagColors = tagColors
      }
    },
  },
  methods: {
    fetchTitle (event) {
      if (event) {
        this.postcolor = !this.tags ? '' : this.tagColors[this.tags.findIndex(el => el == event)]
      } else {
        this.postcolor = ''
      }
      //console.log(event,this.aboutLid.tags,this.postcolor);
    },
    getKaizenTeianIdeas(kadaiId) {
      var self = this
      let tags = this.aboutLid?.tags?.title || []
      console.log('tags', tags)
      let tagColors = this.aboutLid?.tags?.color || []
      let genjoKadaiIndex = tags.findIndex(el => el == '現状の課題')
      if (genjoKadaiIndex > -1) {
        tags.splice(genjoKadaiIndex, 1)
        tagColors.splice(genjoKadaiIndex, 1)
      } else {
        console.log('現状の課題が見つかりませんでした。')
      }
      this.tags = tags
      this.tagColors = tagColors
    },
    //コメント・修正提案関係関数
    upAmendment() {// 修正提案
      this.pjamendments = []
      this.isAC = false
      let self = this,amindex,amdata
      this.setAmendment = this.db.collection("0").doc(this.$route.params.id).collection("project").doc(this.pjuid).collection('amendments').orderBy('createdAt').where("isActive","==",true)
      .onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
          //console.log('PROJECTchange: ', change.doc.data())
          //console.log("amCHANGE")
          if(change.type === "added") {
            const isNew = self.pjamendments.some(el => el.id === change.doc.id)
            if(isNew) console.log("二重登録")
            else{
              //console.log("AMadded: ", change.doc.id,change.doc.data())
              amdata = change.doc.data()
              self.$set(amdata, "id", change.doc.id)
              self.pjamendments.push(amdata)
            }
          }
          if(change.type === "modified") {
            const isNew = self.pjamendments.some(el => el.id === change.doc.id)
            if(isNew){
              amdata = change.doc.data()
              self.$set(amdata, "id", change.doc.id)
              amindex = self.pjamendments.findIndex((el)=>el.id===change.doc.id)
              self.pjamendments.splice(amindex,1,amdata) //変更処理
              //console.log(amindex,"AMModified: ", self.pjamendments[amindex])
            }          
          }
          if(change.type === "removed") {
            //console.log("AMRemoved: ", change.doc.data())
            amindex = self.pjamendments.findIndex((el)=>el.id===change.doc.id)
            self.pjamendments.splice(amindex,1) //削除処理
          }
          //console.log("AM現在",self.pjamendments.length)
        })
      })
    },
    upComment() { //コメント取得
      this.pjcomments = []
      this.isAC = false
      let self = this,cmindex,cmdata
      //console.log("upcomments",this.aboutpj.title,this.pjuid,this.pjcomments)
      this.db.collection("0").doc(this.$route.params.id).collection("project").doc(this.pjuid).collection('comments').orderBy('createdAt').where("isActive","==",true)
      .onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
          //console.log('PROJECTchange: ', change.doc.data())
          //console.log("cmCHANGE i:",i)
          if (change.type === "added") {
            const isNew = self.pjcomments.some(el => el.id === change.doc.id)
            if(isNew) console.log("")
            else{
              cmdata = change.doc.data()
              self.$set(cmdata, "id", change.doc.id)
              self.pjcomments.push(cmdata)
              //console.log("added: ", change.doc.id,cmdata)
            }
          }
          if (change.type === "modified") {
            const isNew = self.pjcomments.some(el => el.id === change.doc.id)
            if(isNew){
              cmdata = change.doc.data()
              self.$set(cmdata, "id", change.doc.id)
              cmindex = self.pjcomments.findIndex((el)=>el.id===change.doc.id)
              self.pjcomments.splice(cmindex,1,cmdata) //変更処理
              //console.log(cmindex,"Modified: ", self.pjcomments[cmindex])
            }
          }
          if (change.type === "removed") {
            cmindex = self.pjcomments.findIndex((el)=>el.id===change.doc.id)
            //console.log("Removed: ",cmindex, change.doc.data())
            self.pjcomments.splice(cmindex,1) //削除処理
          }
        })
        //console.log("現在",self.pjcomments)
      })
      this.getAproject()
    },
    getAproject(){ //自分の匿名投稿を取得し、反映。 匿名投稿をしているのはチャットだけなので、チャットのみ対応、修正提案非対応
      let self = this
      let collection = this.db.collection("0").doc(this.$route.params.id).collection("project").doc(this.pjuid).collection("aproject").doc(this.uid)
      collection.get().then((doc) => {
        //console.log("aproject処理開始",self.uid,doc.exists)
        if (doc.exists) {
          let cmindex = "", cmdata = ""
          let acomments = doc.data().acomments
          //console.log("aproject Document data:", doc.data(),acomments)
          if(acomments){
            self.isAC = true
            acomments.forEach((el) => {
              //console.log("el", el)
              //console.log('pjcomments',self.pjcomments)
              cmindex = self.pjcomments.findIndex(pjcm => pjcm.id == el)
              // //console.log(cmindex)
              if(cmindex!==-1){
                //自分匿名投稿のauthorに自分のuidをセット
                cmdata = self.pjcomments[cmindex]
                //console.log(el,cmindex,cmdata,self.uid,self.pjcomments[cmindex])
                self.$set(cmdata,"author",self.uid)
                self.pjcomments.splice(cmindex, 1, cmdata)
                self.anonymitys.push(el)
              }
            })            
          }

        }
      }).catch((error) => {
        //console.log("Error getting document:", error);
      })
    },
    doLike(index,likeif){
      var self = this
      //console.log("いいね発動"+self.contentUid+likeif)
      if(this.isAuthed){
        if(likeif){ //いいね仮解除
          if(this.contentType==='comments') this.pjcomments[index].like.splice(this.pjcomments[index].like.indexOf(this.uid),1)
          else if(this.contentType==='amendments') this.pjamendments[index].like.splice(this.pjamendments[index].like.indexOf(this.uid),1)
          else if(this.contentType==='idea') this.ideaThreads[index].like.splice(this.ideaThreads[index].like.indexOf(this.uid),1)
        }
        else{ //いいね仮登録
          if(this.contentType==='comments') this.pjcomments[index].like.push(this.uid)
          else if(this.contentType==='amendments') this.pjamendments[index].like.push(this.uid)
          else if(this.contentType==='idea') this.ideaThreads[index].like.push(this.uid)
        }
        if(this.contentType==='comments'||this.contentType==='amendments'){
          firebase.functions().httpsCallable('projectLiked')({
            lidid: this.$route.params.id,
            pjuid: this.pjuid,
            id: this.contentUid,
            uid: this.uid,
            type: this.contentType
          })          
        }
        else if(this.contentType==='idea'){
          firebase.functions().httpsCallable('ideaThreadLiked')({
            lidid: this.$route.params.id,
            ideauid: this.ideaId,
            uid: this.uid,
            thuid: this.ideaThreads[index].id
          })
        }
      }
    },
    submitComment(){
      if(this.comment == this.comment_) this.same = true
      if (!this.isSubmittable) {
        // チャット投稿条件を満たしているかどうかを判定
        return
      }
      this.comment_ = this.comment
      let self = this,author = "anonymity"
      this.today()
      if(!this.isAnonymity||this.contentType==='amendments') author = this.uid
      if(this.contentType==='idea'){
        this.db.collection("0").doc(this.$route.params.id).collection("idea").doc(this.ideaId).collection("thread").add({
          content: this.comment,
          author: author,
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
          updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
          sort: this.todayy,
          day: this.timeday,
          hour: this.timehour,
          like: [],
          edit: false,
          isActive:true,
          isReply: this.isReply,
          replyId: this.replyId,
          isMention: this.isMention,
          mentionId: this.mentionId,
          anonymous: this.isAnonymity,
        }).then(function(docRef) {
          // 保存に成功した時
          //console.log("comments Document written with ID: ", docRef.id)
          self.clearChatTempData()
          if(self.isAnonymity){
            //チャットのみ
            let aideas = self.db.collection("0").doc(self.$route.params.id).collection("liduser").doc(self.uid).collection("aidea").doc("aideas")
            aideas.set({
              athreads: firebase.firestore.FieldValue.arrayUnion(docRef.id),
            },{merge:true})
            aideas = self.db.collection("0").doc(self.$route.params.id).collection("aidea").doc(self.ideaId).collection("thread").doc(docRef.id)
            aideas.set({
              author: self.uid,
              id: docRef.id
            },{merge:true})
            self.anonymitys.push(docRef.id)
          }
        }).catch(function(error) {
          // 保存に失敗した時
          console.error("comments Error adding document: ", error);
        })
      }
      else if(this.contentType==='comments'||this.contentType==='amendments'){
        this.db.collection("0").doc(this.$route.params.id).collection("project").doc(this.pjuid).collection(this.contentType).add({
          content: this.comment,
          author: author,
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
          updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
          sort: this.todayy,
          day: this.timeday,
          hour: this.timehour,
          like: [],
          edit: false,
          isActive:true,
          isReply: this.isReply,
          replyId: this.replyId,
          isMention: this.isMention,
          mentionId: this.mentionId,
          anonymous: this.isAnonymity,
          chatImage: this.chatImage,
          tag: {
            color: this.postcolor,
            title: this.tag
          }
        }).then(function(docRef) {
          // 保存に成功した時
          //console.log("comments Document written with ID: ", docRef.id)
          self.comment=""
          if(self.contentType==="comments") self.$refs.activityfunc.comments(self.$route.params.id,self.pjuid,docRef.id,self.comment);
          else if(self.contentType==="amendments") self.$refs.activityfunc.amendments(self.$route.params.id,self.pjuid,docRef.id,self.comment);
          self.clearChatTempData()
          if(self.isAnonymity&&self.contentType==='comments'){
            //チャットのみ
            self.anonymitySubmitComment(docRef.id)
            self.anonymitys.push(docRef.id)
          }
        }).catch(function(error) {
          // 保存に失敗した時
          console.error("comments Error adding document: ", error);
        })        
      }
    },
    anonymitySubmitComment(id){
      let self = this
      if(this.contentType==="idea"){
        this.db.collection("0").doc(this.$route.params.id).collection("aidea").doc(this.ideaId).collection("thread").doc(id).set({
          id: id,
          author: self.uid
        },{merge:true}).then(function(docRef) {
          // 保存に成功した時
          //console.log("comments Document written with ID: ", docRef.id)
          //console.log("aidea",id)
        }).catch(function(error) {
          // 保存に失敗した時
          console.error("aidea Error adding document: ", error);
        })
      }
      else{
        if(this.isAC){
          this.db.collection("0").doc(this.$route.params.id).collection("project").doc(this.pjuid).collection('aproject').doc(this.uid).update({
            id: this.uid,
            acomments: firebase.firestore.FieldValue.arrayUnion(id),
          }).then(function(docRef) {
            // 保存に成功した時
            //console.log("comments Document written with ID: ", docRef.id)
            //console.log("aproject",id)
          }).catch(function(error) {
            // 保存に失敗した時
            console.error("comments Error adding document: ", error);
          })        
        }
        else{
          this.db.collection("0").doc(this.$route.params.id).collection("project").doc(this.pjuid).collection('aproject').doc(this.uid).set({
            id: this.uid,
            acomments: firebase.firestore.FieldValue.arrayUnion(id),
          },{merge:true}).then(function(docRef) {
            // 保存に成功した時
            //console.log("aproject",id)
          }).catch(function(error) {
            // 保存に失敗した時
            console.error("comments Error adding document: ", error);
          })
        }        
      }

    },
    clearChatTempData(){
      this.comment=''
      this.isReply = false
      this.replyId = ""
      this.replyContent = ""
      this.isMention = false
      this.mentionId = ""
      this.resetImage()
    },
    submitctrl(){
      if(this.isSubmittable){
        this.submitComment(), this.comment=''
      }
    },
    editctrl(){
      this.editPage = false
      this.editContent=''      
      if(this.editContent.length >= 1) this.doEditContent()
    },
    //Comment編集
    doEditContent(){
      let self = this
      //console.log(this.contentType,"編集：",this.contentUid)
      if(this.contentType==='idea'){
        this.db.collection("0").doc(this.$route.params.id).collection("idea").doc(this.ideaId).collection("thread").doc(this.contentUid).update({
          content: self.editContent,
          updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
          edit: true
        }).then(function(docRef) {
          // 保存に成功した時
          //console.log("comments Document written with ID: ", docRef.id)
        }).catch(function(error) {
          // 保存に失敗した時
          console.error("comments Error adding document: ", error);
        })  
      }
      else{
        this.db.collection("0").doc(this.$route.params.id).collection("project").doc(this.pjuid).collection(this.contentType).doc(this.contentUid).update({
          content: self.editContent,
          updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
          edit: true
        }).then(function(docRef) {
          // 保存に成功した時
          //console.log("comments Document written with ID: ", docRef.id)
        }).catch(function(error) {
          // 保存に失敗した時
          console.error("comments Error adding document: ", error);
        })        
      }
    },
    //Comment削除
    doDeleteContent(){
      //console.log(this.contentType,"削除：",this.contentUid)
      if(this.contentType==='idea'){
        this.db.collection("0").doc(this.$route.params.id).collection("idea").doc(this.ideaId).collection("thread").doc(this.contentUid).set({
          isActive: false,
          deleteUid: this.uid,
          //deleteCurrentName: this.currentName,
          deletedAt: firebase.firestore.FieldValue.serverTimestamp(),
        },{merge:true}).then(function(docRef) {
          // 保存に成功した時
          //console.log("comments Document written with ID: ", docRef.id)
        }).catch(function(error) {
          // 保存に失敗した時
          console.error("comments Error adding document: ", error);
        })  
      }
      else{
        this.db.collection("0").doc(this.$route.params.id).collection("project").doc(this.pjuid).collection(this.contentType).doc(this.contentUid).update({
          isActive: false,
          deleteUid: this.uid,
          //deleteCurrentName: this.currentName,
          deletedAt: firebase.firestore.FieldValue.serverTimestamp(),
        }).then(function(docRef) {
          // 保存に成功した時
          //console.log("comments Document written with ID: ", docRef.id)
        }).catch(function(error) {
          // 保存に失敗した時
          console.error("comments Error adding document: ", error);
        })        
      }
    },
    closeAuthModal() {
      this.authModal = false
    },
    closeProfile() {
      this.profile = false;
    },
    reload(){
      this.$router.go({path: this.$router.currentRoute.path, force: true})
    },
    //画像のアップロード
    onFileChange(e) {
      this.filename = Math.random().toString(36).slice(2);
      this.tasks = 1;
      //console.log("onFileChange");
      const files = e.target.files || e.dataTransfer.files;
      //this.createImage(files[0]);
      // 拡張子で分ける（※.が1つの想定です）
      const imgNameExe = files[0].name.split(".");
      // 拡張子から前
      let imgName = imgNameExe[0];
      // 拡張子から後ろ
      const imgExe = imgNameExe[1];
      this.imgExe = imgExe;
      //StorageにUP
      this.originImg(files[0]);
      /*
      // 表示したい文字のMaxのByte数（全角10文字、半角20文字）
      const maxBytes = 20;
      const imgNameBytes = encodeURIComponent(imgName).replace(
        /%../g,
        "x"
      ).length;

      // 画像ファイルとMax Byte数の比較
      if (imgNameBytes > maxBytes) {
        const zenkaku = imgNameBytes - imgName.length;
        if (zenkaku > 0) {
          imgName = imgName.slice(0, maxBytes / 2 - imgName.length) + "..";
        } else {
          imgName = imgName.slice(0, maxBytes - imgNameBytes) + "..";
        }
      }

      // 短くカットしたものと.と拡張子の文字列の連結
      imgName = imgName + "." + imgExe;
      //this.img_name = imgName;
      */
    },
    originImg(file) {
      let self = this;
      const payload = {
        quality: 0.8,
        mimeType: "image/jpeg",
        success(blob) {
          var reader = new FileReader();
          reader.onloadend = () => {
            const result = reader.result;
            if (result instanceof ArrayBuffer || result === null) return;
            self.upImg2Storage(result, self.filename + ".jpeg");
          };
          reader.readAsDataURL(blob);
        },
        error(err) {
          //console.log(err.message);
        },
      };
      new Compressor(file, payload);
    },
    upImg2Storage(file, filename) {
      let self = this;

      const uploadTask = firebase.storage().ref()
        .child("projects/" + this.$route.params.id + "/"  + this.pjuid + "/chat/" + filename)
        .putString(file, "data_url", {
          customMetadata: {uid: self.uid}
        });

      // Listen for state changes, errors, and completion of the upload.
      uploadTask.on(
        "state_changed", // or 'state_changed'
        (snapshot) => {
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          //console.log("Upload is " + progress + "% done");
          switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED: // or 'paused'
              //console.log("Upload is paused");
              break;
            case firebase.storage.TaskState.RUNNING: // or 'running'
              //console.log("Upload is running");
              break;
          }
        },
        (error) => {
          switch (error.code) {
            case "storage/unauthorized":
              console.error("upImage/storage/unauthorized");
              break;
            case "storage/canceled":
              console.error("upImage/storage/canceled");
              break;
            case "storage/unknown":
              console.error("upImage/storage/unknown");
              break;
          }
        },
        () => {
          let filepath = "projects/" + this.$route.params.id + "/" + this.pjuid + "/chat/" + filename;
          const ref = firebase.storage().ref(filepath);
          ref.getDownloadURL().then((url) => {
            self.chatImage = url;
            self.tasks = self.tasks - 1;
          });
        }
      );
    },
    resetImage(){
      this.chatImage = ""
      this.filename = ""
    },

    //初期読込関数
    //プロジェク状態変更関係関数
    toDoubleDigits(num) {
        num += "";
        if (num.length === 1) {
          num = "0" + num;
        }
      return num; 
    },
    today(){
      // 日付をYYYY/MM/DD HH:DD:MI:SS形式で取得
      let date = new Date();
      let yyyy = date.getFullYear();
      let mm = this.toDoubleDigits(date.getMonth() + 1)
      let dd = this.toDoubleDigits(date.getDate())
      let hh = this.toDoubleDigits(date.getHours())
      let mi = this.toDoubleDigits(date.getMinutes())
      let se = this.toDoubleDigits(date.getSeconds())
      let ms = this.toDoubleDigits(date.getMilliseconds())
      this.todayy = yyyy + mm + dd + hh + mi + se + ms
      this.timeday= mm+"/"+dd
      this.timehour= hh+":"+mi
    },
  }
}
</script>
  
<style scoped>
*{
  font-family:mplus-2c-medium !important;
}
.h50 {
  height:50dvh !important;
}
.h54 {
  max-height:54dvh !important;
}
.h55 {
  height:65dvh !important;
}
.h72 {
  height:72dvh !important;
}
.h80 {
  height:80dvh !important;
}
.h70 {
  height:70dvh !important;
}
.h66 {
  height:66dvh !important;
}
.entire {
  width: 100%;
  margin-top: 7px;
  color: #707070;
  padding-left: 5px;
  border-left: solid;
  border-color: rgb(109, 109, 109);
}
.disablevm >>> .v-messages {
  min-height: 0px !important;
}
.disablevm >>> .v-input__slot{
  margin-bottom: 0px !important;
}
.chat-scroll::-webkit-scrollbar{
   width: 10px;
}
.chat-scroll::-webkit-scrollbar-track{
   background-color: #dcdcdc;
}
.chat-scroll::-webkit-scrollbar-thumb{
   background-color: #008cff;
   border-radius: 4px;
}
.input-item {
  cursor: pointer;
  color: #ffffff;
}
.input-item input[type="file"] {
  display: none;
}
/*
::-webkit-scrollbar {
  display: none;
}
::-webkit-scrollbar-track {
  background-color: rgba(120, 170, 210,0.3);
  border-radius: 100px;
}
::-webkit-scrollbar-thumb {
  background: #78aad2;
  border-radius: 100px;
  width: 130px;
}

  */
  </style>